import Typography from '@mui/material/Typography';
import { Button } from './Button';
import { Modal } from './Modal';

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** true renders the confirm button in error red (delete flows, Figma 3095:53742) */
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      title={title}
      onClose={onCancel}
      actions={
        <>
          <Button variant="secondary" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button
            variant="primary"
            onClick={onConfirm}
            sx={danger ? { backgroundColor: '#FC4D2B', '&:hover': { backgroundColor: '#d63c1e' } } : undefined}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <Typography fontSize={14} color="text.secondary">
        {message}
      </Typography>
    </Modal>
  );
}
